import React, { useContext, useEffect, useRef, useState } from 'react';
import secureLocalStorage from 'react-secure-storage';
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import VegIcon from "../../Icon/veg.svg";
import NonVegIcon from "../../Icon/nonveg.svg";
import SubAddonItemData from './SubAddonItemData';
import AddonItemData from './AddonItemData';
import { showToast } from '../../showTost';
const ImageLoad = ({ BaseUrl, url, CustomeStyle }) => {
    const [imgLoaded, setImgLoaded] = useState(false);

    if (!url) {
        return;
    }

    return (<>
        <img
            src={`${BaseUrl}/${url}`}
            alt="Model"
            loading="lazy"
            onLoad={() => setImgLoaded(true)}
            onError={() => setImgLoaded(true)}
            className={`${CustomeStyle} transition-opacity duration-300 ${imgLoaded ? "opacity-100" : "opacity-0"}`}
        />
    </>)
}

const Search = () => {

    const { BaseUrl, callHomeApi, iscustomisable, setIsCustomisable, customisableitem, setCustomisableItem, setTotalCart } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState("");
    const [coords, setCoords] = useState({ lat: 0, long: 0 });
    const [searchdata, setSearchData] = useState([]);
    const [searchload, setSearchLod] = useState(false);
    const [selectitem, setSelectItem] = useState();
    const [selectaddonitem, setSelectAddonItem] = useState([]);
    const [itemstate, setItemState] = useState([]);
    const [addonlimit, setAddonLimit] = useState("0");
    const [selectitemprice, setSelectItemPrice] = useState(0);
    const [isshow, setIsShow] = useState(false);
    const [copydata, setCopyData] = useState("");
    const [isrepeat, setIsRepeat] = useState(false);
    const [selectrepeatorder, setSelectRepeatOrder] = useState("");
    const [repeatradiobtn, setRepeatRadioBtn] = useState(false);
    const [repeatorderlist, setRepeatOrderList] = useState("");
    const [localcartdata, setLocalCartData] = useState([]);
    const [status, setStatus] = useState(false);
    const [isstep, setIsStep] = useState("1");
    const [subaddonshow, setSubAddonShow] = useState(false);
    const [subAddonData, setSubAddonData] = useState("");

    const StyleRef = useRef();
    const navigate = useNavigate();
    const Location = useLocation();
    const ResName = Location.state.title;

    const currency = secureLocalStorage.getItem("currency");
    const rid = Location.state.rest_id;

    useEffect(() => {

        const IsAddedLocation = secureLocalStorage.getItem("Location");
        if (IsAddedLocation) {
            const { lat, long } = JSON.parse(IsAddedLocation);
            setCoords({ lat, long });
        } else {
            navigator.geolocation.getCurrentPosition(
                position => {
                    const lat = position.coords.latitude;
                    const long = position.coords.longitude;
                    setCoords({ lat, long });
                }
            )
        }


        if (Location.state.searchtype) {
            setSearchData([]);
            setSearch("");
        }

        setTimeout(() => {
            setLoading(false);
        }, 1000);

    }, [callHomeApi]);

    useEffect(() => {
        if (search) {
            setSearchLod(true);
            if (Location.state.searchtype === 1) {
                handleSearchRestaurant();
            } else {
                handleSearchItem();
            }
        }
    }, [search]);

    useEffect(() => {
        iscustomisable
            ? document.body.style.overflow = "hidden"
            : document.body.style.overflow = "auto"
    }, [iscustomisable]);

    useEffect(() => {
        const TotalAddonPrice = selectaddonitem?.reduce((sum, item) => sum + Number(item.price), 0);
        const TotalAddonPrice2 = itemstate?.map(item => item.data?.reduce((sum, item) => sum + Number(item.price), 0)).join(", ");
        setSelectItemPrice(TotalAddonPrice + Number(TotalAddonPrice2));
    }, [selectaddonitem, itemstate]);

    useEffect(() => {

        if (loading) return;

        if (localcartdata?.length >= 1) {
            const LocalData = secureLocalStorage.getItem("localcartdata");
            if (LocalData) {
                var { restdata } = JSON.parse(LocalData);
            }
            const RestData = {
                rest_id: rid,
            }
            const RestuarantData = restdata ? (status ? RestData : restdata) : RestData;
            const Data = { cartitem: localcartdata, restdata: RestuarantData };
            secureLocalStorage.setItem("localcartdata", JSON.stringify(Data));
        } else {
            secureLocalStorage.removeItem("localcartdata");
        }
        const totalcart = localcartdata.reduce((sum, item) => sum + item.qty, 0);
        setTotalCart(totalcart);
    }, [localcartdata]);

    const handleSearchRestaurant = () => {
        const uid = secureLocalStorage.getItem("Userid") || "0";

        axios.post(`${BaseUrl}/eapi/e_rest_search.php`, { uid, keyword: search, lats: coords.lat, longs: coords.long })
            .then((res) => {
                // console.log("e_rest_search.php", res.data.restuarant_data);
                setSearchData(res.data.restuarant_data);
                setSearchLod(false);
            })
            .catch((error) => {
                console.error("e_rest_search.php", error);
            });
    }

    const handleSearchItem = () => {
        axios.post(`${BaseUrl}/eapi/e_rest_product_search.php`, { rid, keyword: search })
            .then((res) => {
                console.log("e_rest_product_search.php", res.data.Product_Search_Data);
                const LocalData = secureLocalStorage.getItem("localcartdata");
                const ProductData = res.data.Product_Search_Data;
                if (ProductData) {
                    let JsonData = [];
                    if (LocalData) {
                        const { cartitem } = JSON.parse(LocalData);
                        setLocalCartData(cartitem);
                        JsonData = cartitem;
                        const totalcart = cartitem.reduce((sum, item) => sum + item.qty, 0);
                        setTotalCart(totalcart);
                    }
                    const FilterProduct = ProductData.map(item => {
                        if (item.is_customize === "0") {
                            const IsMatchproduct = JsonData.find(data => data.pid === item.id);
                            return IsMatchproduct ? { ...item, totalcart: IsMatchproduct.qty } : item;
                        } else {
                            const IsMatchproduct = JsonData.filter(data => data.pid === item.id);
                            const totalcart = IsMatchproduct.reduce((sum, data) => sum + data.qty, 0);
                            return IsMatchproduct ? { ...item, totalcart } : item;
                        }
                    });
                    setSearchData(FilterProduct);
                }
                setSearchLod(false);
            })
            .catch((error) => {
                console.error("e_rest_product_search.php", error);
            });
    }

    const handleNavigate = (rest_id) => {
        navigate(`/restaurant/${rest_id}`);
    }

    const handleAllFuction = (index, data, RemoveItem) => {
        if (index === 1) {
            handleAddToCart(data);
        } else if (index === 2) {
            handleIncrement(data);
        } else if (index === 3) {
            handleDecrement(data);
            if (RemoveItem) {
                setLocalCartData(RemoveItem);
            }
        } else if (index === 4) {
            const RepeatList = localcartdata.filter(item => item.pid === data.id && item.addon);
            setItemState(RepeatList);
            setRepeatOrderList([...RepeatList]);
            setIsRepeat(true);
        } else if (index === 5) {
            setIsShow(true);
            setCopyData(data);
            setTimeout(() => {
                StyleRef.current.classList.add('item_added_close');
            }, 100);
        } else if (index === 6) {
            setSelectItem(data);
            handleFilterData(data);
            setIsCustomisable(true);
        }

        if (index === 4 || index === 5 || index === 6) {
            const GetLength = data.addondata.some(item => item.addon_item_data.some(item => item.subaddondata.length >= 1));
            setAddonLimit(GetLength ? data.required_step : 0);
        }
    }

    const handleFilterData = (data) => {
        const FilterData = data.addondata.map(addon => {
            if (!addon.additem) {
                if (addon.addon_is_radio === "1" && addon.addon_is_required === "1") {
                    setSelectAddonItem(prev => [...prev, addon.addon_item_data[0]]);
                    if (addon.addon_item_data[0].subaddondata.length >= 1) {
                        setAddonLimit(1);
                    } else {
                        setItemState(prev => {
                            const exists = (prev || []).some(item => item.title === "Order");
                            if (exists) {
                                return (prev || []).map(item => {
                                    if (item.title === "Order") {
                                        return { ...item, data: [...item.data, addon.addon_item_data[0]] };
                                    }
                                    return item;
                                });
                            } else {
                                return [...(prev || []), { title: "Order", data: [addon.addon_item_data[0]] }];
                            }
                        });
                    }
                    return { ...addon, additem: "1" }
                }
                return addon;
            }
            return addon;
        });
        setCustomisableItem({ ...data, addondata: FilterData });
    }

    const handleCloseModel = (index) => {
        if (index === 1) {
            setIsCustomisable(false);
            setSelectItemPrice(0);
            setSelectItem("");
            setSubAddonShow(false);
            setIsStep("1");
        } else if (index === 2) {
            setSubAddonShow(false);
            setIsStep("1");
        } else {
            setIsRepeat(false);
            setRepeatRadioBtn(false);
            setSelectRepeatOrder("");
        }
        setItemState([]);
        setSelectAddonItem([]);
    }

    const handleContinue = () => {
        const someHaveNoSubaddons = selectaddonitem.some(item => item.subaddondata.length <= 0);

        if (someHaveNoSubaddons) {
            handleAddToCart(customisableitem, 1);
            return;
        }

        setIsStep("1");
        setSubAddonShow(true);
    }

    const handleAddToCart = (data) => {

        const matchedOrders = localcartdata.filter(order => order.pid === data.id);
        let isError = false;

        if (matchedOrders.length >= 1) {

            const AllMatch = itemstate.every(item => {
                return matchedOrders.some(order => {
                    return order.addon.some(data => {
                        return data.title === item.title;
                    });
                });
            });

            if (AllMatch) {

                const checkMatchingTitles = (matchedOrders, itemstate) => {
                    return itemstate.every(selectedItem => {
                        return matchedOrders.some(order => {
                            return order.addon.some(addon => {
                                const addonTitles = addon.data.map(d => d.title).sort();
                                const selectedTitles = selectedItem.data.map(d => d.title).sort();
                                if (addonTitles.length !== selectedTitles.length) return false;
                                return addonTitles.every((title, index) => title === selectedTitles[index]);
                            });
                        });
                    });
                };
                const isValid = checkMatchingTitles(matchedOrders, itemstate);

                if (!isValid) {
                    isError = true;
                } else {
                    handleIncrement(data);
                    setIsCustomisable(false);
                    setSelectItemPrice(0);
                    setSelectAddonItem([]);
                    handleCloseModel(2);
                    setStatus(false);
                }

            } else {
                isError = true;
            }

        } else {
            isError = true;
        }

        if (isError) {

            if (status) {
                setLocalCartData("");
                setTimeout(() => {
                    handleAddNewItem(data);
                }, 100);
                return;
            }

            handleAddNewItem(data);
        }

    };

    const handleAddNewItem = (data) => {

        let selectedItemData;

        const updatedsearchdata = searchdata.map(menuItem => {
            if (menuItem.id === data.id) {
                const newQty = menuItem.totalcart ? menuItem.totalcart + 1 : 1;
                const totalAddonPrice = Number(data?.price) + Number(selectitemprice);
                selectedItemData = {
                    pid: menuItem.id,
                    price: data?.price,
                    title: menuItem.title,
                    cost: data.is_customize === "1" ? totalAddonPrice : totalAddonPrice * newQty,
                    copycost: data.is_customize === "1" ? totalAddonPrice : totalAddonPrice * newQty,
                    qty: data.is_customize === "1" ? 1 : newQty,
                    is_customize: data.is_customize,
                    addon: itemstate,
                    type: data.is_veg,
                };
                return { ...menuItem, totalcart: newQty };
            }
            return menuItem;
        });

        setLocalCartData(prev => [...prev, selectedItemData]);
        setSearchData(updatedsearchdata);
        setIsCustomisable(false);
        setSelectItemPrice(0);
        setSelectAddonItem([]);
        handleCloseModel(2);
        setStatus(false);
    };

    const handleIncrement = (data) => {

        const FilterData = searchdata.map((item) => {
            if (item.id === data.id) {
                const Count = item.totalcart + 1;
                return { ...item, totalcart: Count }
            }
            return item;
        });

        const LocalFilterData = localcartdata.map((product) => {
            if (product.pid === data.id) {
                const Count = product.qty + 1;
                const cost = product.is_customize === "1" ? (product.copycost * Count) : (product.price * Count);
                return { ...product, qty: Count, cost }
            }
            return product;
        });

        setLocalCartData(LocalFilterData);
        setSearchData(FilterData);
    }

    const handleDecrement = (data) => {

        const FilterData = searchdata.map((item) => {
            if (item.id === data.id) {
                const Count = item.totalcart - 1;
                return { ...item, totalcart: Count }
            }
            return item;
        });

        const UpdatedCart = localcartdata.map(product => {
            if (product.pid === data.id) {
                const Count = product.qty - 1;
                if (Count === 0) return null;
                return { ...product, qty: Count, cost: (product.cost - Number(product.price)) };
            }
            return product;
        }).filter(Boolean);

        setLocalCartData(UpdatedCart);
        setSearchData(FilterData);
    }

    const handleRepeatOrder = () => {
        if (itemstate.length >= 2) {
            setRepeatRadioBtn(true);
            if (repeatradiobtn && !selectrepeatorder) {
                showToast({ title: "Select repeat order !!", id: "error" });
                return;
            }

            if (selectrepeatorder) {
                setLocalCartData(prev => [...prev, itemstate[selectrepeatorder - 1]]);
                setRepeatRadioBtn(false);
                setSelectRepeatOrder("");
                setIsRepeat(false);
                setItemState([]);
                handleIncrement(selectitem);
            }
        } else {
            setLocalCartData(prev => [...prev, ...itemstate]);
            setRepeatRadioBtn(false);
            setIsRepeat(false);
            setRepeatRadioBtn("");
            handleIncrement(selectitem);
            setItemState([]);
        }
    }

    const handleShowModel = (index) => {

        StyleRef.current.classList.remove('item_added_close');
        setTimeout(() => {
            setIsShow(false);
        }, 500);

        if (index === 1) {
            if (copydata.is_customize === "0") {
                setLocalCartData([]);
                setTimeout(() => {
                    handleAddToCart(copydata);
                }, 200);
            } else {
                setTimeout(() => {
                    setSelectItem(copydata);
                    handleFilterData(copydata);
                    setIsCustomisable(true);
                    setStatus(true);
                }, 200);
            }

        }
    }

    return (
        <div className='search_page'>
            <div className="search_width">
                <div className="">

                    <div className="bg-white pb-[20px] pt-[30px] sticky top-[90px] z-[777] px-[10px]">
                        <div className="flex items-center gap-[10px]">
                            <button onClick={() => navigate(-1)}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M21.7501 12C21.7501 12.414 21.4141 12.75 21.0001 12.75H4.81115L10.5311 18.47C10.8241 18.763 10.8241 19.238 10.5311 19.531C10.3851 19.677 10.1931 19.751 10.0011 19.751C9.80909 19.751 9.61706 19.678 9.47106 19.531L2.47106 12.531C2.40206 12.462 2.3472 12.3791 2.3092 12.2871C2.2332 12.1041 2.2332 11.8971 2.3092 11.7141C2.3472 11.6221 2.40206 11.539 2.47106 11.47L9.47106 4.46999C9.76406 4.17699 10.2391 4.17699 10.5321 4.46999C10.8251 4.76299 10.8251 5.23803 10.5321 5.53103L4.81213 11.251H21.0001C21.4141 11.25 21.7501 11.586 21.7501 12Z" fill="#25314C" />
                                </svg>
                            </button>
                            <div className="w-full border-[1px] border-gray-300 py-[10px] px-[15px] rounded-[10px]">
                                <div className="flex items-center justify-between gap-[20px]">
                                    <input value={search} onChange={(e) => setSearch(e.target.value)} type="text" className='w-full outline-none font-[500] text-gray-700' placeholder={`Search in ${Location.state.searchtype === 1 ? "restaurant" : ResName}`} />
                                    {searchload
                                        ? <div style={{ width: "21px", height: "20px" }} className="loader"></div>
                                        : <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M21.53 20.47L17.689 16.629C18.973 15.106 19.75 13.143 19.75 11C19.75 6.175 15.825 2.25 11 2.25C6.175 2.25 2.25 6.175 2.25 11C2.25 15.825 6.175 19.75 11 19.75C13.143 19.75 15.106 18.973 16.629 17.689L20.47 21.53C20.616 21.676 20.808 21.75 21 21.75C21.192 21.75 21.384 21.677 21.53 21.53C21.823 21.238 21.823 20.763 21.53 20.47ZM3.75 11C3.75 7.002 7.002 3.75 11 3.75C14.998 3.75 18.25 7.002 18.25 11C18.25 14.998 14.998 18.25 11 18.25C7.002 18.25 3.75 14.998 3.75 11Z" fill="#25314C" />
                                        </svg>}
                                </div>
                            </div>
                        </div>
                    </div>

                    {Location.state.searchtype === 1 && <div className="px-[10px] my-[10px]">
                        {searchdata.length >= 1
                            ? searchdata.map((item, index) => {
                                return <div key={index} onClick={() => handleNavigate(item.rest_id)} className="restaurant_box">
                                    <div className="img_box">
                                        <ImageLoad BaseUrl={BaseUrl} url={item.rest_img} CustomeStyle={"w-full h-full object-cover"} />
                                    </div>
                                    <div className="flex items-start justify-between w-full">
                                        <div className="">
                                            <h1 className='font-bold text-[15px] text-gray-800'>{item.rest_title}</h1>
                                            <div className="flex items-center gap-[5px] justify-between">
                                                <div className="flex items-center gap-[5px]">
                                                    <svg width="15" height="15" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                                                        <circle cx="10" cy="10" r="9" fill="url(#StoreRating20_svg__paint0_linear_32982_71567)"></circle>
                                                        <path d="M10.0816 12.865C10.0312 12.8353 9.96876 12.8353 9.91839 12.865L7.31647 14.3968C6.93482 14.6214 6.47106 14.2757 6.57745 13.8458L7.27568 11.0245C7.29055 10.9644 7.26965 10.9012 7.22195 10.8618L4.95521 8.99028C4.60833 8.70388 4.78653 8.14085 5.23502 8.10619L8.23448 7.87442C8.29403 7.86982 8.34612 7.83261 8.36979 7.77777L9.54092 5.06385C9.71462 4.66132 10.2854 4.66132 10.4591 5.06385L11.6302 7.77777C11.6539 7.83261 11.706 7.86982 11.7655 7.87442L14.765 8.10619C15.2135 8.14085 15.3917 8.70388 15.0448 8.99028L12.7781 10.8618C12.7303 10.9012 12.7095 10.9644 12.7243 11.0245L13.4225 13.8458C13.5289 14.2757 13.0652 14.6214 12.6835 14.3968L10.0816 12.865Z" fill="white"></path>
                                                        <defs>
                                                            <linearGradient id="StoreRating20_svg__paint0_linear_32982_71567" x1="10" y1="1" x2="10" y2="19" gradientUnits="userSpaceOnUse">
                                                                <stop stopColor="#21973B"></stop>
                                                                <stop offset="1" stopColor="#128540"></stop>
                                                            </linearGradient>
                                                        </defs>
                                                    </svg>
                                                    <p className="font-[500] text-gray-800 text-[15px]">{item?.rest_rating}</p>
                                                    <span className="text-gray-500">•</span>
                                                    <p className="font-[500] text-gray-800 text-[15px]">{currency + item?.rest_costfortwo} for two</p>
                                                </div>
                                            </div>
                                            <div className="flex items-center gap-[5px]">
                                                <svg width="17" height="18" viewBox="0 0 24 24" className="text-[--bgcolor]" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12 2.5C7.313 2.5 3.5 6.313 3.5 11C3.5 15.983 8.129 19.041 11.192 21.064L11.722 21.416C11.806 21.472 11.903 21.5 11.999 21.5C12.095 21.5 12.192 21.472 12.276 21.416L12.806 21.064C15.869 19.041 20.498 15.983 20.498 11C20.5 6.313 16.687 2.5 12 2.5ZM12 13.5C10.619 13.5 9.5 12.381 9.5 11C9.5 9.619 10.619 8.5 12 8.5C13.381 8.5 14.5 9.619 14.5 11C14.5 12.381 13.381 13.5 12 13.5Z" fill="currentColor" />
                                                </svg>
                                                <span className="font-[500] text-gray-800 text-[14px]">{item.rest_distance}</span>
                                            </div>
                                        </div>
                                        {item.rest_is_open !== "1" && <h1 className='font-bold text-[15px] text-red-500'>Closed</h1>}
                                    </div>
                                </div>
                            })
                            : ((search && !searchload) && <div className="h-[400px] flex items-center justify-center">
                                <h1 className='font-bold text-[17px] text-gray-500'>Sorry, Restaurant Not Found !!</h1>
                            </div>)
                        }
                    </div>}

                    {Location.state.searchtype === 2 && <div style={{ width: "100%" }} className="px-[10px] my-[10px] restaurant_page">
                        <div className="section_3">
                            {searchdata.length >= 1
                                ? searchdata.map((item, index) => {
                                    return <div key={index} className="product_box">
                                        <ItemData data={item} BaseUrl={BaseUrl} currency={currency} handleAllFuction={handleAllFuction} rest_id={rid} setSelectItem={setSelectItem} setCustomisableItem={setCustomisableItem} />
                                    </div>
                                })
                                : ((search && !searchload) && <div className="mt-[20px] flex items-center justify-center">
                                    <h1 className='font-bold text-[17px] text-gray-500'>Sorry, Food Not Found !!</h1>
                                </div>)
                            }
                        </div>
                    </div>}

                </div>
            </div>


            {iscustomisable && <div onClick={() => handleCloseModel(1)} className="model items-center max-_430_:items-end">
                <div onClick={(e) => e.stopPropagation()} className="customisable_box">

                    <div className="py-[20px] px-[15px]">
                        <div className="flex items-center justify-between">
                            <h1 className="text-[15px] text-gray-600">{selectitem?.title} • {currency + selectitem?.price}</h1>
                            <button onClick={() => handleCloseModel(1)} className="bg-white rounded-full p-[4px] box_shadow" >
                                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z" fill="#25314C" />
                                </svg>
                            </button>
                        </div>
                        <p className="text-[20px] font-bold text-gray-800 border-b-[1px] pb-[10px] border-gray-300">Customise as per your taste</p>
                    </div>

                    {!subaddonshow && <div className="h-[100%] pb-[20px] px-[15px] scroll_container">
                        {customisableitem.addondata.map((addon, index) => {
                            const Required = addon.addon_limit;
                            return <div key={index} className="addondata_box" >
                                <div className="flex items-center gap-[10px]">
                                    <h1 className="title">{addon.title}</h1>
                                    {addon.addon_is_radio === "1"
                                        ? <span className="font-bold text-[16px] text-gray-500">
                                            ({addon.additem || "0"}/{"1"})
                                        </span>
                                        : (Required !== "0" && <span className="font-bold text-[16px] text-gray-500">
                                            ({addon.additem || "0"}/{Required})
                                        </span>)}
                                </div>

                                <div className="bg-white pt-[10px] px-[15px] rounded-[10px] my-[10px]">
                                    {addon.addon_item_data.map((dataItem, index) => {
                                        const hasSubAddon = dataItem.subaddondata?.length >= 1;
                                        return (
                                            <AddonItemData
                                                index={index}
                                                Required={Required}
                                                key={dataItem.id}
                                                addondata={addon}
                                                data={dataItem}
                                                currency={currency}
                                                setSelectAddonItem={setSelectAddonItem}
                                                selectaddonitem={selectaddonitem}
                                                hasSubAddon={hasSubAddon}
                                                setSubAddonData={setSubAddonData}
                                                setItemState={setItemState}
                                                itemstate={itemstate}
                                                isedit={0}
                                            />
                                        );
                                    })}
                                </div>
                            </div>
                        })}
                    </div>}

                    {subaddonshow && <div className="h-[100%] pb-[20px] px-[15px] scroll_container">

                        <div className="bg-white px-[15px] py-[20px] rounded-[10px] mb-[10px]">
                            <div className="flex items-center gap-[10] justify-between">
                                <h1 className="font-[500] text-[16px]">• {subAddonData?.title}</h1>
                                <button onClick={() => handleCloseModel(2)} className="font-bold text-[16px] text-[--bgcolor]">Change</button>
                            </div>
                        </div>

                        {subAddonData.subaddondata.map((addon, index) => {
                            const Required = addon.addon_limit;
                            return <div key={index} className="addondata_box">
                                <div className="flex items-center gap-[10px]">
                                    <h1 className="title">{addon.title}</h1>
                                    {addon.addon_is_radio === "1"
                                        ? <span className="font-bold text-[16px] text-gray-500">
                                            ({addon.additem || "0"}/{addon.addon_is_required})
                                        </span>
                                        : (Required !== "0" && <span className="font-bold text-[16px] text-gray-500">
                                            ({addon.additem || "0"}/{Required})
                                        </span>)}
                                </div>

                                <div className="bg-white pt-[10px] px-[15px] rounded-[10px] my-[10px]">
                                    {addon.subon_item_data.map((dataItem, index) => {
                                        return (
                                            <SubAddonItemData
                                                index={index}
                                                Required={Required}
                                                key={dataItem.id}
                                                addondata={addon}
                                                data={dataItem}
                                                currency={currency}
                                                hasSubAddon={true}
                                                setSubAddonData={setSubAddonData}
                                                subAddonData={subAddonData}
                                                setItemState={setItemState}
                                                itemstate={itemstate}
                                                selectaddonitem={selectaddonitem}
                                                isedit={0}

                                            />
                                        );
                                    })}
                                </div>

                            </div>
                        })}
                    </div>}

                    <div className="bg-white p-[16px] flex items-center justify-between gap-[20px]">
                        <div className="font-bold text-[18px]">
                            {addonlimit !== 0 ? ((!subaddonshow)
                                ? <h1>Step ({isstep}/{addonlimit})</h1>
                                : <h1>{currency}{Number(selectitemprice) + Number(selectitem?.price)} </h1>)
                                : <h1>{currency}{Number(selectitemprice) + Number(selectitem?.price)} </h1>}
                        </div>
                        <button onClick={() => (addonlimit !== 0 && !subaddonshow) ? handleContinue() : handleAddToCart(customisableitem)} className="w-[300px] bg-[rgb(27,166,114)] text-white font-bold text-[18px] py-[8px] rounded-[12px]">
                            {(addonlimit !== 0 && !subaddonshow)
                                ? <span>Continue</span>
                                : <span>Add Item to cart</span>}
                        </button>
                    </div>

                </div>

            </div>}

            {isrepeat && <div onClick={() => handleCloseModel(3)} className="model items-center">
                <div onClick={(e) => e.stopPropagation()} className="bg-[#f1f2f4] w-[500px] flex flex-col max-h-[80vh] rounded-[15px] overflow-hidden">

                    <div className="py-[20px] px-[15px]">
                        <div className="flex items-center justify-between">
                            <h1 className="text-[16px] text-gray-600">{selectitem?.title}</h1>
                            <button onClick={() => handleCloseModel(3)} className="bg-white rounded-full p-[4px] box_shadow" >
                                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z" fill="#25314C" />
                                </svg>
                            </button>
                        </div>
                        <p className="text-[22px] font-bold text-[rgba(2,6,12,0.75)] border-gray-300 -mt-[10px]">Repeat previous customisation?</p>
                    </div>

                    <div className="h-[100%] mx-[15px] scroll_container">
                        {repeatorderlist.map((order, orderindex) => {
                            const isSelect = orderindex === (selectrepeatorder - 1);
                            return order.addon.map((addon, addonindex) => {
                                return <div key={addonindex} onClick={() => setSelectRepeatOrder(orderindex + 1)} className={` ${repeatradiobtn ? "cursor-pointer" : "cursor-auto"} my-[8px] bg-white px-[15px] py-[10px] rounded-[10px]`}>
                                    <div className="flex items-center justify-between gap-[20px]">
                                        <h1 className="font-[600] text-gray-800">{addon.title} {addon.title === "Order" && orderindex + 1}</h1>
                                        {repeatradiobtn && <div className={`${isSelect ? "border-[#ff5200]" : "border-gray-500"} border-[2px] rounded-full p-[3px]`}>
                                            <div className={`w-[8px] h-[8px] ${isSelect ? "bg-[#ff5200]" : "bg-transparent"} rounded-full`}></div>
                                        </div>}
                                    </div>
                                    {addon.data.length >= 1
                                        ? addon.data?.map((item, itemIndex) => (
                                            <h1 key={itemIndex} className="text-[rgba(2,6,12,0.75)]">• {item.title}</h1>
                                        ))
                                        : <h1 className="text-[rgba(2,6,12,0.75)]">• {order.title}</h1>}
                                </div>
                            })
                        })}
                    </div>

                    <div className="bg-white p-[16px] flex items-center justify-between gap-[20px] mt-[20px]">
                        <button onClick={() => { setItemState([]); setIsRepeat(false); setIsCustomisable(true) }} className="w-full border-[1px] border-[rgb(27,166,114)] text-[rgb(27,166,114)] font-bold text-[16px] py-[8px] rounded-[12px]">I’ll choose</button>
                        <button onClick={handleRepeatOrder} className="w-full bg-[rgb(27,166,114)] text-white font-bold text-[16px] py-[8px] rounded-[12px]">Repeat</button>
                    </div>
                </div>
            </div>}

            {isshow && <div onClick={handleShowModel} className="w-full h-[100vh] fixed left-0 right-0 bottom-0 flex items-end justify-center z-[888]">
                <div ref={StyleRef} onClick={(e) => e.stopPropagation()} className="item_added">
                    <h1>Items already in cart</h1>
                    <p className="text-[15px] leading-5 text-[rgba(2,6,12,.8)] font-[500]">Your cart contains items from other restaurant. Would you like to reset your cart for adding items from this restaurant?</p>
                    <div className="flex items-center gap-[20px] mt-[20px]">
                        <button onClick={handleShowModel} className="w-full border-[2px] border-[#1ba672] text-[#1ba672] font-bold text-[15px] py-[10px] hover:shadow-lg rounded-[10px]">NO</button>
                        <button onClick={() => handleShowModel(1)} className="w-full border-[2px] border-[#1ba672] bg-[#1ba672] text-white font-bold text-[15px] py-[10px] hover:shadow-lg rounded-[10px]">YES, START AFRESH</button>
                    </div>
                </div>
            </div>}

        </div>
    )
}

export default Search;

const ItemData = ({ data, BaseUrl, currency, handleAllFuction, rest_id, setSelectItem, setCustomisableItem }) => {

    const isAdded = data.totalcart >= 1;
    const isOpen = secureLocalStorage.getItem("isopen");

    const [isOverflowing, setIsOverflowing] = useState(false);
    const [showmore, setShowMore] = useState(false);
    const [showerror, setShowError] = useState(false);

    const descRef = useRef(null);

    useEffect(() => {
        const element = descRef.current;

        if (element) {
            const lineHeight = parseFloat(getComputedStyle(element).lineHeight);
            const maxLines = 2;
            const isTextOverflowing = element.scrollHeight > lineHeight * maxLines;
            setIsOverflowing(isTextOverflowing);
        }
    }, [data.cdesc]);

    const handleShowBox = (data) => {

        console.log(data);

        const LocalData = secureLocalStorage.getItem("localcartdata");

        if (LocalData) {
            const { restdata } = JSON.parse(LocalData);
            if (rest_id !== restdata.rest_id) {
                handleAllFuction(5, data);
                return;
            }
        }

        if (data.is_customize === "0") {
            handleAllFuction(1, data);
            return;
        }

        handleAllFuction(6, data);
    };

    const handleIncrement = () => {

        if (data.is_customize === "1" && data.totalcart >= 1) {
            handleAllFuction(4, data);
            setSelectItem(data);
            setCustomisableItem(data);
            return;
        }

        handleAllFuction(2, data);
    };

    const handleDecrement = () => {
        const LocalData = secureLocalStorage.getItem("localcartdata");
        if (LocalData) {
            var { cartitem } = JSON.parse(LocalData);
        }

        if (data.is_customize === "1" && data.totalcart >= 1) {
            checkOrderAddons(cartitem, data.id);
            return;
        }

        handleAllFuction(3, data);
    };

    const checkOrderAddons = (orders, targetPid) => {

        const matchedOrders = orders.filter(order => order.pid === targetPid);

        if (matchedOrders.length === 1) {
            const RemoveItem = orders.filter(order => order.pid !== targetPid);
            handleAllFuction(3, data, RemoveItem);
            return;
        }

        if (matchedOrders.length > 1) {

            const [first, ...rest] = matchedOrders;
            const firstAddons = first.addon.map(item => item.title).join(", ");
            const firsTitle = [...firstAddons].sort().join(',');

            const AllAddon = rest.every(item => {
                return item.addon.every(addon => {
                    const currentAddons = [...addon.title].sort().join(',');
                    return currentAddons === firsTitle;
                })
            });

            if (AllAddon) {

                const firesOrderTitle = first.addon.map(item => {
                    return item.data.map(item => item.title)
                }).join(", ");

                const SortTitle = [...firesOrderTitle].sort().join(",");

                const allMatch = rest.every(item => {
                    return item.addon.every(addon => {
                        return addon.data.every(data => {
                            const currentAddons = [...data.title].sort().join(',');
                            return currentAddons === SortTitle;
                        })
                    })
                });

                if (allMatch) {
                    const RemoveItem = orders.find(order => order.pid === targetPid);
                    handleAllFuction(3, data, [RemoveItem]);
                } else {
                    setShowError(true);
                    setTimeout(() => {
                        setShowError(false);
                    }, 5000);
                }

            } else {
                setShowError(true);
                setTimeout(() => {
                    setShowError(false);
                }, 5000);
            }
        }
    };

    return <div className="item_box">
        <div className={`py-[20px] flex ${data.item_img ? "items-start" : "items-center"} justify-between gap-[20px] relative`}>
            <div className="detail_box">
                {data.is_veg === "1"
                    ? <div className="w-[20px]">
                        <img src={VegIcon} alt="VegIcon" />
                    </div>
                    : <div className="w-[20px]">
                        <img src={NonVegIcon} alt="NonVegIcon" />
                    </div>}
                <h1 className="title">{data.title}</h1>
                <p className="font-[700] text-gray-800 py-[8px]">{currency + data.price}</p>
                {data.cdesc && (
                    <div className="flex items-end">
                        <p
                            ref={descRef}
                            className={`text-gray-800 ${showmore ? '' : 'line-clamp-2'} transition-all duration-300`}
                        >
                            {data.cdesc}
                        </p>
                        {!showmore && isOverflowing && (
                            <button
                                onClick={() => setShowMore(true)}
                                className="ml-2 font-medium text-gray-500"
                            >
                                More
                            </button>
                        )}
                    </div>
                )}
            </div>

            <div className="img_box">
                <ImageLoad BaseUrl={BaseUrl} url={data.item_img} CustomeStyle={isOpen === "1" && "-mb-[25px]"} />
                {isOpen === "1" && <div className="">
                    <div className="flex justify-center">
                        {isAdded
                            ? <div className="isAdded">
                                <span onClick={handleDecrement}>-</span>
                                <p>{data.totalcart}</p>
                                <span onClick={handleIncrement}>+</span>
                            </div>
                            : <button onClick={() => handleShowBox(data)}>ADD</button>}
                    </div>
                    {data.is_customize === "1" && <p className="text-center text-gray-500 text-[14px]">Customisable</p>}
                </div>}
            </div>
        </div>

        {showerror && <div className="absolute -bottom-[80px] right-[65px] z-[666]">
            <div className="error_box">
                <span>This item has multiple customizations added. Remove the correct item from the cart.</span>
            </div>
        </div>}
    </div>
}